'use strict';

var AudioPlayer = require('./AudioPlayer');

module.exports = AudioPlayer.default;